





import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class TimePicker extends Vue {
  formatted: string | null =  null;
  hasError: boolean = false;
  lastEmitted: number | null | undefined = null;

  @Prop() private value!: number | null;
  @Prop({ default: undefined }) from: number | undefined;

  get formattedTime() {
    if (this.formatted) {
      return this.formatted;
    } else {
      return '';
    }
  }

  set formattedTime(time: string) {
    this.formatted = this.formatTime(time);
  }

  @Watch('value', { immediate: true }) onValueChange(newVal: number, prevVal: number) {
    if (!isNaN(Number(this.value)) && this.value !== null && newVal !== this.lastEmitted) {
      // Set default times, adding 0 if numeric value under 10
      let minutesFromMidnight = this.value;
      if (minutesFromMidnight > 1440) {
        minutesFromMidnight = minutesFromMidnight % 1440;
      }
      const hoursNum = Math.floor(minutesFromMidnight / 60);
      const hours = hoursNum < 10 ? '0' + hoursNum : hoursNum + '';
      const minutesNum = this.value % 60;
      const minutes = minutesNum < 10 ? '0' + minutesNum : minutesNum + '';

      this.formatted = this.formatTime(`${hours}:${minutes}`);
    }
    if (newVal === null) {
      this.formatted = '';
    }
  }

  @Watch('formatted')onFormattedChange(val: any) {
    let emitValue;
    if (!!val) {
      const timeSplit = this.formattedTime.split(':');
      const hours = Number(timeSplit[0]);
      const minutes = Number(timeSplit[1]);
      let timeValue = (hours * 60) + minutes;

      if (this.from && this.from > timeValue) {
        timeValue += 1440;
      }
      emitValue = this.hasError ? NaN : timeValue;
      // if (this.value && this.value > 1440) {
      //   emitValue = this.value;
      // }
    }
    this.lastEmitted = emitValue;
    this.$emit('input', emitValue);
  }

  validateInput(e: KeyboardEvent) {
    const acceptedChars = [
      /\d/, /Backspace/, /Delete/, /ArrowLeft/, /ArrowRight/, /Shift/,
      /Control/, /ArrowUp/, /ArrowDown/, /Alt/, /Home/, /\cA/, /Tab/, /\t/,
    ];

    const modifierPressed = e.ctrlKey;
    const acceptedCommands = ['a', 'A', 'c', 'C', 'V', 'v', 'Z', 'z', 'x', 'X'];
    const allowedCommand = modifierPressed && acceptedCommands.includes(e.key);

    const selObj = document.getSelection();
    const selection = selObj ? selObj.toString() : '';
    const noNumbersOrLetters = acceptedChars.slice(1, acceptedChars.length - 1);
    
    // Only accept numbers and control characters
    if (!this.isAcceptedChar(e.key, acceptedChars) && !allowedCommand) {
      e.preventDefault();
      return;
    }
    // Input cannot exceed 5 characters hh:mm
    if (this.formatted && this.formatted.length >= 5) {
      // Do not accept number input if nothing is selected
      if (!selection) {
        if (!this.isAcceptedChar(e.key, noNumbersOrLetters)) {
          e.preventDefault();
          return;
        }
      } else if (this.formattedTime.indexOf(selection) !== -1) {
        // Allow overwriting selection with numbers
        return;
      } else {
        e.preventDefault();
        return;
      }
    }
    const isNumber = /\d/.test(e.key);
    if (isNumber && !this.isAcceptedValue(e.key) && !selection) {
        e.preventDefault();
    }

  }

  isAcceptedChar(key: string, acceptedChars: RegExp[]) {
    let isAccepted = false;
    acceptedChars.forEach(reg => {
      if (reg.test(key)) {
        isAccepted = true;
        return isAccepted;
      }
    });
    return isAccepted;
  }

  isAcceptedValue(key: string) {
    const time = this.formatted ? this.formatted.replace(/\D/g, '') : '';

    // 4th digit, cases: [0-1, 0-9 : 0-5, 0-9] OR [0-2, 0-3 : 0-5, 0-9]
    if (time.length === 3) {
      return Number(time[0]) <= 1 ?
        Number(time[2]) <= 5 :
        Number(time[0]) <= 2 && Number(time[1]) <= 3 && Number(time[2]) <= 5;
    }

    // 3rd digit, if 2nd digit is over 5, time has to be [1, 0-9 : 3rd digit]
    if (time.length === 2) {
      return Number(time[1]) > 5 ? Number(key) <= 5 : true;
    }

    if (time.length === 1) {
      return Number(time[0]) > 1 ? Number(key) <= 5 : true;
    }

    return true;
  }

  formatTime(time: string) {
    // Clear non numeric parts of the string.
    time = time.replace(/\D/g, '');
    if (time.length > 4) {
      time = time.substring(0, 4);
    }

    const hours = time.length > 2 ? time.substring(0, time.length - 2) : '';
    const minutes = time.substring(time.length - 2, time.length);

    this.hasError = Number(hours) > 23 || Number(minutes) > 59;

    return hours || minutes ? `${hours}:${minutes}` : '';
  }

}
